export const PAC_AIR_EAU = 'pompe à chaleur air - eau';
